import type { BaseLeadsSearchRow, LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";

export const rowTypeGuard = {
    isWebsiteBaseTableRow<R extends BaseLeadsSearchRow>(
        row: R | undefined = {} as R,
    ): row is R & Required<Pick<LeadsSearchRow, "site">> {
        return "site" in row;
    },

    isCompanyDomainsBaseTableRow<R extends BaseLeadsSearchRow>(
        row: R | undefined = {} as R,
    ): row is R & Required<Pick<LeadsSearchRow, "company" | "company_domains">> {
        return "company" in row && "company_domains" in row;
    },
};
